import {
  CouponType,
  OnSiteLocationType,
  OrderMethod,
  PaymentMethod,
  RefundReason,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Información del pedido',
  sections: {
    driver_info: 'Info del conductor',
    order_info: 'Información del pedido',
    price_info: 'Información de precios',
    adjustments: 'Ajustes',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Recogida',
    [OrderMethod.Delivery]: 'Entrega',
    [OnSiteLocationType.RoomService]: 'Servicio a la habitación',
    [OnSiteLocationType.TableService]: 'Servicio en mesa',
  },
  room_service_location_types: {
    [OnSiteLocationType.RoomService]: {
      details_label: 'Número de habitación',
    },
    [OnSiteLocationType.TableService]: {
      details_label: 'Número de mesa',
    },
  },
  labels: {
    wolt_support: 'Teléfono de soporte Wolt: {{phone_number}}',
    wolt_support_text:
      'Si tienes alguna pregunta sobre el pedido, el conductor o algún problema, llama a Wolt. Es importante indicar que es un pedido de <strong>Wolt Drive</strong>',
    dummy_order: 'Pedido de prueba',
    asap: 'ASAP',
    driver_name: 'Nombre del conductor',
    driver_phone_number: 'Teléfono del conductor',
    pin_code: 'PIN',
    dropoff_pin_code: 'PIN de entrega',
    original: 'Original',
    delivery_fee: 'Tarifa de entrega',
    tip: 'Propina',
    service_fee: 'Procesamiento en línea',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'Tarifa PayPal',
    },
    promo_applied: {
      default: 'Promoción aplicada',
      [CouponType.Reward]: 'Puntos de fidelidad aplicados',
      [CouponType.Cashback]: 'Puntos de fidelidad aplicados',
      [CouponType.PromoCode]: 'Promoción aplicada',
      [CouponType.GiftCard]: 'Tarjeta regalo aplicada',
    },
    tax: 'Impuestos',
    total: 'Total',
    online_payment: 'El cliente ya pagó en la app de {{provider}}',
    cash_payment: 'Pago en el local',
    invoice_payment: 'Pago mediante factura',
    old_order: 'Este pedido se completó correctamente',
    pickup_time: 'Hora de recogida',
    pickup_asap: 'El cliente ha solicitado la recogida lo antes posible.',
    points_used: 'Este pedido incluye un canje de puntos de fidelidad',
    order_note: 'Nota del pedido:',
    today: 'hoy',
  },
  schedule: {
    header: 'Programado para el {{date}} a las {{time}}',
    text: 'Te avisaremos cuando sea el momento de empezar a preparar el pedido',
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Solicitado por el cliente',
    [RefundReason.Reclamation]: 'Reclamación',
    [RefundReason.CommunicationError]: 'Error de comunicación',
    [RefundReason.Other]: 'Otro',
    [RefundReason.Dispute]: 'Disputa del cliente',
    dispute_win: 'Disputa ganada',
    null: '',
  },
  toasts: {
    print_one: 'Imprimiendo {{count}} recibo: Pedido <strong>#{{orderNumber}}</strong>...',
    print_other: 'Imprimiendo {{count}} recibos: Pedido <strong>#{{orderNumber}}</strong>...',
    refund_successful: 'Reembolso realizado: Pedido <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Imprimir',
    confirm: 'Confirmar',
    reject: 'Rechazar',
    refund: 'Reembolsar',
  },
};
